<template>
    <div class="contact">
        <h1 class="sr-only">Pauline Fuchs - Contact</h1>
        <div class="container contact__wrapper">
            <div class="contact__text">
                <FormContactSide v-if="content" :content="content.contact"/>
            </div>
            <div class="contact__form">
                <FormContact/>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

import type { SiteOptions } from '~/types/options'

const { getContentAcf } = useWordpressApi()

const { data: content, pending } = await useAsyncData<SiteOptions | null>(
  'acf-options',
  () => getContentAcf()
)

useSeoMeta({
    title: `Pauline Fuchs - Demande de contact`,
    ogTitle:  `Pauline Fuchs - Demande de contact`,
    description: "Besoin d'un devis ? Ou envie de se rencontrer ? Ecrivez moi via votre canal préféré : mail, DM.. Je vous répondrais rapidement ! ",
    ogDescription: "Besoin d'un devis ? Ou envie de se rencontrer ? Ecrivez moi via votre canal préféré : mail, DM.. Je vous répondrais rapidement ! Pour discuter de vive voix via un premier rendez-vous gratuit, vous pouvez aussi réserver un créneau dans mon calendrier en ligne !",
    ogImage: '/hero-photo.png',
})

</script>

<style lang="scss">
    .contact{
        &__wrapper{
            display: flex;
            align-items: center;
            @media screen and (max-width:1600px){
                max-width:95%;
            }
            @media screen and (max-width:1250px) {
                flex-direction: column;
                max-width:1000px;
            }
            @media screen and (max-width:1000px) {
                flex-direction: column;
                max-width:100%;
            }
        }
        &__text{
            color:$text;
            width: 60%;
            @media screen and (max-width:1250px) {
                width: 100%;
            }
           
        }
        &__form{
            width: 40%;
            @media screen and (max-width:1250px) {
                width: 100%;
            }
        }
    }
</style>